import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/shared/types/state';

import { ChatNewState } from './actions';

export const selectMessageSound = (state: RootState): string | null => state.chatNew.messageSound;

export const selectSideBarOpen = (state: RootState): boolean => state.chatNew.sideBarOpen;

export const selectView = (state: RootState): ChatNewState['view'] => state.chatNew.view;

/**
 * Selects all chat inputs from the Redux store
 * @param state - The root Redux state
 * @returns Object mapping sessionId to input text
 */
export const selectChatInputs = (state: RootState): { [sessionId: string]: string } =>
  state.chatNew.chatInputs;

/**
 * Selects the chat input for a specific session
 * @param state - The root Redux state
 * @param sessionId - The session ID to get input for
 * @returns The input text for the session or empty string if not found
 */
export const selectChatInput = (state: RootState, sessionId: string): string =>
  state.chatNew.chatInputs[sessionId] || '';

// Individual memoized selectors for each view property
export const selectViewSelectedStatus = createSelector(selectView, (view) => view.selectedStatus);

export const selectViewSelectedAgent = createSelector(selectView, (view) => view.selectedAgent);

export const selectViewSelectedDepartment = createSelector(
  selectView,
  (view) => view.selectedDepartment
);

export const selectViewSelectedBrain = createSelector(selectView, (view) => view.selectedBrain);

export const selectViewSelectedSort = createSelector(selectView, (view) => view.selectedSort);

export const selectViewSelectedView = createSelector(selectView, (view) => view.selectedView);

export const selectViewTitle = createSelector(selectView, (view) => view.title);
